import { AuthProvider, SubscriptionStatus, SubscriptionType, UserRole } from '../../types/user';

// ========== 표시 라벨 ==========
export const ROLE_LABELS: Record<UserRole, string> = {
    [UserRole.SUPER_ADMIN]: '슈퍼관리자',
    [UserRole.ADMIN]: '관리자',
    [UserRole.USER]: '사용자',
};
export const PROVIDER_LABELS: Record<AuthProvider, string> = {
    [AuthProvider.GOOGLE]: 'Google',
    [AuthProvider.APPLE]: 'Apple',
    [AuthProvider.EMAIL]: 'Email',
    [AuthProvider.KAKAO]: 'Kakao',
    [AuthProvider.UNKNOWN]: 'Unknown',
};
export const SUBSCRIPTION_TYPE_LABELS: Record<SubscriptionType, string> = {
    [SubscriptionType.FREE]: '무료',
    [SubscriptionType.MONTHLY]: '월간',
    [SubscriptionType.YEARLY]: '연간',
    [SubscriptionType.LIFETIME]: '평생',
};
export const SUBSCRIPTION_STATUS_LABELS: Record<SubscriptionStatus, string> = {
    [SubscriptionStatus.ACTIVE]: '활성',
    [SubscriptionStatus.EXPIRED]: '만료',
    [SubscriptionStatus.CANCELLED]: '취소',
    [SubscriptionStatus.REFUNDED]: '환불',
};
export const SUBSCRIPTION_STATUS_COLORS: Record<SubscriptionStatus, 'success' | 'default' | 'error' | 'warning'> = {
    [SubscriptionStatus.ACTIVE]: 'success',
    [SubscriptionStatus.EXPIRED]: 'default',
    [SubscriptionStatus.CANCELLED]: 'warning',
    [SubscriptionStatus.REFUNDED]: 'error',
};

// 깃털(XP) 내역 reason 라벨 — 미지의 reason은 그대로 표시
const FEATHER_REASON_LABELS: Record<string, string> = {
    EPPI_COSTUME_PURCHASE: '코스튬 구매',
    MISSION_REWARD: '미션 보상',
    LEARNING_WORD: '학습 적립',
    OTHER: '기타',
};
export const featherReasonLabel = (reason: string): string => FEATHER_REASON_LABELS[reason] ?? reason;

// ========== 날짜 포맷 ==========
export const KST_TIME_ZONE = 'Asia/Seoul';
export const parseServerDate = (s?: string | null): Date | null => {
    if (!s) return null;
    const base = s.trim().replace(' ', 'T').replace(/\.(\d{3})\d+/, '.$1');
    const normalized = /[zZ]|[+-]\d{2}:\d{2}$/.test(base) ? base : `${base}Z`;
    const d = new Date(normalized);
    return Number.isNaN(d.getTime()) ? null : d;
};
export const fmtDate = (s?: string | null): string => {
    const d = parseServerDate(s);
    if (!d) return '-';
    return new Intl.DateTimeFormat('ko-KR', {
        timeZone: KST_TIME_ZONE,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false,
    }).format(d);
};
export const fmtDateOnly = (s?: string | null): string => {
    const d = parseServerDate(s);
    if (!d) return '-';
    return new Intl.DateTimeFormat('ko-KR', {
        timeZone: KST_TIME_ZONE,
        year: 'numeric', month: '2-digit', day: '2-digit',
    }).format(d);
};
export const toKstDateTimeInputValue = (s?: string | null): string => {
    const d = parseServerDate(s);
    if (!d) return '';
    const parts = new Intl.DateTimeFormat('sv-SE', {
        timeZone: KST_TIME_ZONE,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false,
    }).formatToParts(d);
    const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
    return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`;
};
export const kstInputToUtcLocalDateTime = (s?: string): string | undefined => {
    if (!s) return undefined;
    const withOffset = `${s}:00+09:00`;
    const d = new Date(withOffset);
    if (Number.isNaN(d.getTime())) return undefined;
    return d.toISOString().slice(0, 19);
};

// ========== 표시 변환 헬퍼 ==========
export const countryFlag = (code?: string | null): string | null => {
    const c = code?.toUpperCase();
    if (!c || c.length !== 2) return null;
    return String.fromCodePoint(...[...c].map((ch) => 0x1f1e6 - 65 + ch.charCodeAt(0)));
};
